import React, { useEffect, useState, useRef, useCallback } from "react";
import Card from "../ui/Card";
import ConsoleHeader from "./ConsoleHeader";
import InventoryDetails from "./InventoryDetails";
import InventoryController from "../controllers/InventoryController";
import { useSession } from "../hooks/useSession";
import GlobalController from "../controllers/GlobalConroller";
import HomeController from "../controllers/HomeController";
import POSController from "../controllers/POSController";
import CustomersController from "../controllers/CustomersController";
import ReconciliationController from "../controllers/ReconciliationController";
import { ROUTES } from "../utils/Routes";
import SuppliersController from "../controllers/SuppliersController";
import ReportsController from "../controllers/ReportsController";
import Label from "../ui/Label";
import Alert from "../ui/Alert";
import { pubCall } from "../utils/PubSub";
import dayjs from "dayjs";
import OrderProcessingController from "../controllers/OrderProcessingController";
import OrdersController from "../controllers/OrdersController";
import { getSignal } from "../App";
import { showConfirm, showInfo } from "../utils/Utils";
import TestController from "../controllers/TestController";
import { Table } from "react-virtualized";
import Divider from "../ui/Divider";


export default function Console(props) {
    const { signal = {}, title = "" } = props;

    // Reconciliation Only
    let _ws_only = false;
    let flag = process.env.REACT_APP_MODE || "";

    if (flag === "recon") {
        _ws_only = true;
    }
    const WS_ONLY = _ws_only;



    // Set the default to home
    const [active, setActive] = useState((WS_ONLY) ? "reconciliation" : "home");


    // Need to stop scrolling when holding these keys... 
    useEffect(() => {
        const blockedKeys = new Set([
            'ArrowUp',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
            'PageDown',
            'PageUp'
        ]);

        const handler = (e) => {
            if (blockedKeys.has(e.key)) {
                e.preventDefault();
            }
        };

        window.addEventListener('keydown', handler, {
            capture: true,
            passive: false
        });

        return () => {
            window.removeEventListener('keydown', handler, {
                capture: true
            });
        };
    }, []);


    useEffect(() => {
        const handleMove = (e) => {
            window.mouse = [e.clientY, e.clientX];
        };

        window.addEventListener("mousemove", handleMove);
        return () => window.removeEventListener("mousemove", handleMove);
    }, []);


    useEffect(() => {
        pubCall("setting.employee.getAll", {}, (_s, _r) => {
            if (_s) {
                window.employees = _r;
            }
        })
    }, [])


    const init = {
        reconciliation: (WS_ONLY) ? true : false,
        home: (WS_ONLY) ? false : true,
        orders: false,
        customers: false,
        pos: false,
        inventory: false,
        processing: false,
        suppliers: false,
        reports: false,
        test: false,
    }

    const init_routes = {
        home: ROUTES.HOME.MENU,
        orders: ROUTES.ORDERS.ORDERS,
        customers: ROUTES.CUSTOMER.CUSTOMER,
        pos: ROUTES.POS.POS,
        inventory: ROUTES.INVENTORY.INVENTORY,
        processing: ROUTES.PROCESSING.PROCESSING,
        suppliers: ROUTES.SUPPLIERS.SUPPLIERS,
        reports: ROUTES.REPORTS.REPORTS,
        test: ROUTES.MISC.TEST,
    };

    const routeMemory = useRef({ ...init_routes });



    const [mounted, setMounted] = useState({ ...init });

    const [resetKey, setResetKey] = useState(0);

    const show = useCallback((name) => {

        routeMemory.current[name] = window.bm_state.value;
        window.ac = name;

        if (name === "home") {
            window.bm_state.value = ROUTES.HOME.MENU;
            setMounted({ ...init });
            setActive(name);
            setResetKey((k) => k + 1);
            routeMemory.current = { ...init_routes };

        } else {
            window.bm_state.value = routeMemory.current[name];
        }

        setMounted((m) =>
            m[name] ? m : { ...m, [name]: true }
        );
        setActive(name);
    }, []);


    useEffect(() => {
        const onSwitchController = (e) => show(e.detail);
        window.addEventListener("switchController", onSwitchController);
        return () => {
            window.removeEventListener("switchController", onSwitchController);
        }
    }, []);


    //[TEMP] SHOW ONLY RECONCILIATION
    useEffect(() => {
        window.bm_state.value = (WS_ONLY) ? ROUTES.RECONCILIATION.RECONCILIATION : ROUTES.HOME.MENU;
    }, [])


    const [isSuspended, setIsSuspended] = useState(false);

    useEffect(() => {





        if (window.credentials.store_id == 11) {
            showConfirm({
                controller: "home",
                route: window.bm_state.value,
                description: <div style={{ "textAlign": "center" }}>You are logged in as Mosaic Books - Orders are real.  <br /> Do you want to continue?</div>,
                title: "Warning",
                callback: (e) => {
                    if (!e) {
                        window.history.replaceState(null, '', '/');
                        window.location.reload();
                    }
                }
            })
        }

    }, [])




    return (
        <div key={resetKey}>
            {isSuspended && (
                <div
                    onClick={(e) => {
                        setIsSuspended(false);
                    }}

                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 9999,
                        cursor: "pointer",
                    }}
                >
                </div>
            )}


            <div style={{
                // filter: isSuspended ? "grayscale(100%) brightness(0.7)" : "none",
                // transition: "filter 0.2s ease"
            }}>


                {/* //[TEMP] SHOW ONLY RECONCILIATION */}
                <GlobalController controller="global" setController={show} WS_ONLY={WS_ONLY} signal={signal} />
                {/* <div style={{ width: 'clamp(1180px, 100vw, 1440px)', "height": "calc(100vh - 50px)", "minHeight": "598px", "margin": "0 auto" }}>
                    <ConsoleHeader title="" signal={signal} />
                    {drawController()}
                </div> */}

                <div style={{ width: 'clamp(1180px, 100vw, 1440px)', "height": "calc(100vh - 50px)", "minHeight": "598px", "margin": "0 auto" }}>
                    <ConsoleHeader controller="main" title="" signal={signal} />
                    {/* Home */}
                    {WS_ONLY && mounted.reconciliation && (
                        <ReconciliationController WS_ONLY={WS_ONLY} route={ROUTES.RECONCILIATION.RECONCILIATION} setController={show} signal={signal} />
                    )}

                    {/* Home */}
                    {mounted.home && (
                        <div style={{ display: active === "home" ? "block" : "none" }}>
                            <HomeController controller="home" setController={show} signal={{ signal }} />
                        </div>
                    )}

                    {/* Orders */}
                    {mounted.orders && (
                        <div style={{ display: active === "orders" ? "block" : "none" }}>
                            <OrdersController controller="orders" setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Customers */}
                    {mounted.customers && (
                        <div style={{ display: active === "customers" ? "block" : "none" }}>
                            <CustomersController controller="customers" setController={show} signal={signal} />
                        </div>
                    )}

                    {/* POS */}
                    {mounted.pos && (
                        <div style={{ display: active === "pos" ? "block" : "none" }}>
                            <POSController controller="pos" setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Inventory */}
                    {mounted.inventory && (
                        <div style={{ display: active === "inventory" ? "block" : "none" }}>
                            <InventoryController controller="inventory" setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Processing */}
                    {mounted.processing && (
                        <div style={{ display: active === "processing" ? "block" : "none" }}>
                            <OrderProcessingController controller="processing" setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Suppliers */}
                    {mounted.suppliers && (
                        <div style={{ display: active === "suppliers" ? "block" : "none" }}>
                            <SuppliersController controller="suppliers" setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Reports */}
                    {mounted.reports && (
                        <div style={{ display: active === "reports" ? "block" : "none" }}>
                            <ReportsController controller="reports" setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Test */}
                    {mounted.test && (
                        <div style={{ display: active === "test" ? "block" : "none" }}>
                            <TestController controller="test" setController={show} signal={signal} />
                        </div>
                    )}
                </div>
            </div>
            <div style={{ "position": "absolute", top: "0px", left: "0px", "fontSize": "12px" }}>
                {/* <pre>{JSON.stringify(mounted, null, 2)}</pre> */}
            </div>
        </div>
    )
}